import React from 'react'

import { PROVIDERS } from 'consts'
import { T } from 'lib/tolgee'

import { TOLGEE_GLOBALS } from '../../../../utils'

function CardSubtitle({ item }) {
  if (item?.type === 'niches') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.niche.key}>{TOLGEE_GLOBALS.niche.defaultValue}</T>
      </span>
    )
  }

  if (item?.type === 'savedPostSearches') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.ownedTopic.key}>{TOLGEE_GLOBALS.ownedTopic.defaultValue}</T>
      </span>
    )
  }

  if (item?.type === 'trendings') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.trending.key}>{TOLGEE_GLOBALS.trending.defaultValue}</T>
      </span>
    )
  }

  if (item?.type === 'tags') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.tag.key}>{TOLGEE_GLOBALS.tag.defaultValue}</T>
      </span>
    )
  }

  const providerName = PROVIDERS?.[item?.provider]?.NAME

  if (item?.type === 'creators') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.creator.key}>{TOLGEE_GLOBALS.creator.defaultValue}</T> - {providerName}
      </span>
    )
  }

  if (item?.type === 'posts') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.video.key}>{TOLGEE_GLOBALS.video.defaultValue}</T> - {providerName}
      </span>
    )
  }

  if (item?.type === 'industry_topic') {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.category.key}>{TOLGEE_GLOBALS.category.defaultValue}</T>
      </span>
    )
  }

  if (['topics', 'subtopics'].includes(item?.type)) {
    return (
      <span className="CardContentBar-title-provider">
        <T keyName={TOLGEE_GLOBALS.topic.key}>{TOLGEE_GLOBALS.topic.defaultValue}</T>
      </span>
    )
  }

  return null
}

export default CardSubtitle
